import $ from 'jquery';

// Add a DOM ready event listener to scroll to the correct position on the page when taking the sticky navigation
// into account
$(function () {
    let hash = (window.location.hash).toString().replace(/^#/, '');
    if (hash && $('#' + hash).length) {
        if (window.scrollY > 0 && $('.navigation.sticky-top').length) {
            window.scrollTo(window.scrollX, window.scrollY - $('.navigation.sticky-top').height());
        }
    }
});

export default {};